import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useStyles } from "../../assets/styles/Theme";
import Navbar from "../../components/common/Navbar";
import { useNavigate } from "react-router-dom";
import ViewData from "../../components/grids/ViewDatagrid";
import { Autocomplete, TextField } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import { useTheme } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";

import { Emailsetupdata } from "../../assets/Griddata"; // Import dataset
import {
  LOCATION_API_01,
  SHOP_API_01,
  USERS_EMAIL_SETUP_API_02,
} from "../../api/ApiModel";
import { externalgetApi } from "../../services/external/externalApis";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
function ViewEmailsetup() {
  const [searchText, setSearchText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [filteredData, setFilteredData] = useState(null);
  const [filteredRows, setFilteredRows] = useState([]);
  // const [data, setData] = useState(null);
  const [data, setData] = useState([]);
  const [shops, setShops] = useState([]);
  const [dataemail, setDataemail] = useState([]);
  const [selectedLOC, setSelectedLOC] = useState("");
  const [selectedSHOP, setSelectedSHOP] = useState("");
  const [dataloc, setDataloc] = useState([]);
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const [selectedLocCode, setSelectedLocCode] = useState("");
  const [selectedrestcode, setSelectedrestcode] = useState("");
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, GROUPCODE, USERNAME, sendmailcode, USERREFCODE } =
    SYS_USER.USER_PARAM || {};

  const goToPage = () => {
    navigate("/emailsetup");
  };

  const goToPageview = () => {
    navigate("/GenerateQR");
  };

  // useEffect(() => {
  //   if (data) {
  //     const filtered = data.filter((item) =>
  //       item.sendmailcode.toLowerCase().includes(searchText.toLowerCase())
  //     );
  //     setFilteredData(filtered);
  //   }
  // }, [searchText, data]);

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  const handleItemClick = (id, actionText) => {
    const selectedItem = dataemail.find((item) => item.MAILACTIONCODE === id);
    selectedItem.LOCCODE = selectedLocCode;
    selectedItem.RESTCODE = selectedrestcode;
    if (selectedItem) {
      if (actionText === "Edit") {
        navigate(`/emailsetup`, { state: { selectedItem, actionText } });
      } 
    }
  };

  const menuItems = [
    {
      text: "Setup",
      icon: <BorderColorOutlinedIcon />,
      onClick: (MAILACTIONCODE) => handleItemClick(MAILACTIONCODE, "Edit"),
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(SHOP_API_01, "get", {
          COMPCODE: COMPCODE,
          GROUPCODE: GROUPCODE,
          USERNAME: USERNAME,
  
          STS: CON_STATUS_ACTIVE,
        });
        setData(result);

        setIsLoading(false);
      } catch (err) {
        console.error("Error fetching data:", err);
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const filteredShops = Array.isArray(data)
          ? data.filter(shop => shop.LOCCODE === selectedLocCode)
          : [];
        setShops(filteredShops);
  }, [selectedLocCode,dataloc]);

  console.log("selectedLocCode", selectedLocCode);
  console.log("dataemail", selectedrestcode);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(USERS_EMAIL_SETUP_API_02, "get", {
          COMPCODE: COMPCODE,
          LOCCODE: selectedLocCode,
          RESTCODE: selectedrestcode,
        });
        setDataemail(result); // <-- Set the fetched data here
        setIsLoading(false);
      } catch (err) {
        console.error("Error fetching data:", err);
        setIsLoading(false);
      }
    };
    fetchData();
  }, [selectedLocCode, selectedrestcode]);

  // Build rows from dataemail
  console.log("dataemail for grid", dataemail);
  const rows = Array.isArray(dataemail)
    ? dataemail.map((item, index) => ({
        id: index + 1,
        sendmailcode: item.sendmailcode,
        SUBJECT: item.SUBJECT,
        BODYTEXT: item.BODYTEXT,
        WEBCONTENT: item.WEBCONTENT,
        FOOTERCONTENT: item.FOOTERCONTENT,
        FROMMAIL: item.FROMMAIL,
        SENDER: item.SENDER,
        MAILACTION: item.MAILACTION,
        INTERVAL: item.INTERVAL,
        MAILACTIONCODE: item.MAILACTIONCODE,
      }))
    : [];
  console.log("rows", rows);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const result = await externalgetApi(SHOP_API_01, "get", {
  //         COMPCODE: COMPCODE,
  //         GROUPCODE: GROUPCODE,
  //         USERNAME: USERNAME,
  //         // CATTYPE: "R",
  //         STS: CON_STATUS_ACTIVE,
  //       });
  //       setData(result);

  //       console.log("result", result);
  //       setIsLoading(false);
  //     } catch (err) {
  //       console.error("Error fetching data:", err);
  //       setIsLoading(false);
  //     }
  //   };
  //   fetchData();
  // }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(LOCATION_API_01, "get", {
          COMPCODE,
          GROUPCODE,
          USERNAME,
          STS: CON_STATUS_ACTIVE, // Fetch only items where STS is 'A'
        });

        setDataloc(result);
        console.log("Filtered Locations:", result);
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleSelectionloc = (newValue) => {
    if (newValue && newValue.LOCCODE) {
      setSelectedLOC(newValue);
      setSelectedLocCode(newValue.LOCCODE);
    } else {
      setSelectedLocCode("");
      setSelectedLOC(null);
    }
  };

  const handleSelectionshop = (newValue) => {
    if (newValue && newValue.RESTCODE) {
      setSelectedSHOP(newValue);
      setSelectedrestcode(newValue.RESTCODE);
    } else {
      setSelectedSHOP("");
      setSelectedrestcode(null);
    }
  };

  useEffect(() => {
    if (Array.isArray(dataloc) && dataloc.length > 0 && !selectedLOC) {
      setSelectedLOC(dataloc[0]); // Set the first item as the default
      setSelectedLocCode(dataloc[0].LOCCODE); // Set the first item's LOCCODE as the default
    }
  }, [dataloc, selectedLOC]);

  // useEffect(() => {
  //   if (Array.isArray(data) && data.length > 0 && !selectedSHOP) {
  //     setSelectedSHOP(data[0]); // Set the first shop as default
  //     setSelectedrestcode(data[0].RESTCODE); // Set the first shop's RESTCODE as default
  //   }
  // }, [data, selectedSHOP]);
  useEffect(() => {
  if (shops.length > 0) {
    setSelectedSHOP(shops[0]);
    setSelectedrestcode(shops[0].RESTCODE);
  }
}, [shops,selectedLocCode]);

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Email Setup</Link>
                <Link underline="none">View Email Setup</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item>
              <Stack
                sx={styles.AI_fixedStack1}
                direction="row"
                justifyContent="flex-end"
                spacing={2}
                padding={1}
              >
                <Autocomplete
                  options={Array.isArray(dataloc) ? dataloc : []}
                  getOptionLabel={(option) => option.LOCATION || ""}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Location"
                      size="small"
                      variant="outlined"
                      sx={{ width: 300 }}
                    />
                  )}
                  onChange={(event, newValue) => {
                    handleSelectionloc(newValue); // Update the state correctly
                  }}
                  value={selectedLOC}
                  ListboxProps={{
                    style: {
                      maxHeight: 150,
                      backgroundColor: theme.palette.background.paper,
                    },
                  }}
                  noOptionsText={
                    <div
                      style={{
                        backgroundColor: theme.palette.background.paper,
                        padding: "8px",
                      }}
                    >
                      No options
                    </div>
                  }
                  loading={isLoading}
                />

                <Autocomplete
                  options={Array.isArray(shops) ? shops : []}
                  getOptionLabel={(option) => option.RESTNAME || ""}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Shop"
                      size="small"
                      variant="outlined"
                      sx={{ width: 300 }}
                    />
                  )}
                  onChange={(event, newValue) => {
                    handleSelectionshop(newValue); // Update the state correctly
                  }}
                  value={selectedSHOP}
                  ListboxProps={{
                    style: {
                      maxHeight: 150,
                      backgroundColor: theme.palette.background.paper,
                    },
                  }}
                  noOptionsText={
                    <div
                      style={{
                        backgroundColor: theme.palette.background.paper,
                        padding: "8px",
                      }}
                    >
                      No options
                    </div>
                  }
                  loading={isLoading}
                />
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "60vh",
          }}
        >
          <CircularProgress color="primary" />
        </Box>
      ) : (
        <ViewData
          columns={Emailsetupdata.columns}
          rows={rows}
          menuItems={menuItems}
          tabletitle={Emailsetupdata.name}
          gridid="MAILACTIONCODE"
        />
      )}
    </div>
  );
}

export default ViewEmailsetup;
